// extracted by mini-css-extract-plugin
export default {"container":"SpinWheelImageLoader_container__FDQtz"};